module.exports = __webpack_public_path__ + "img/ic_dashboard_battle_lose.9dc8d877.svg";